import React from 'react';

import { STEPPER_CONSTANTS } from '../../../../constants';

interface ConnectingLineProps {
  index: number;
  isLast: boolean;
  currentStepIndex: number;
}

const ConnectingLine: React.FC<ConnectingLineProps> = ({
  index,
  isLast,
  currentStepIndex
}) => {
  if (isLast) return null;

  const isActive = index < currentStepIndex;
  const lineColor = isActive
    ? STEPPER_CONSTANTS.COLORS.CONNECTING_LINE_ACTIVE
    : STEPPER_CONSTANTS.COLORS.CONNECTING_LINE_INACTIVE;

  return (
    <div
      className="h-0.5 w-6 transition-colors duration-200 lg:w-7 xl:w-9 2xl:w-14 3xl:w-20"
      style={{ backgroundColor: lineColor }}
    />
  );
};

export default ConnectingLine;
